<template>
    <div class="fillcontain">
        <div class="table_container">
          <el-row>
            <el-col :span="4">
              <el-input placeholder="请输入 名称/昵称/帐号" v-model="pages.keyword" class="input-with-select">
              </el-input>
            </el-col>
            <el-col :span="3" style="margin-left: 10px">
              <el-button @click="initData">搜索</el-button>
            </el-col>

          </el-row>
          <br/>
            <el-table
                :data="tableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column label="头像">
                <template slot-scope="scope">
                  <img :src="scope.row.photoUrl" v-if="scope.row.photoUrl != null" width="50" height="50"/>
                </template>
              </el-table-column>

              <el-table-column
                label="昵称"
                prop="nickName">
              </el-table-column>
              <el-table-column
                label="帐号"
                prop="user.account"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                label="状态"
                :formatter="statusFormat">
              </el-table-column>
              <el-table-column
                label="性别"
                :formatter="sexFormat"
              >
              </el-table-column>
              <el-table-column
                label="城市/地区"
                :formatter="cityFormat"
              >
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">

                  <el-button
                    size="mini"
                    @click="detail(scope.row)">
                    详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>



        </div>




    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                plugin:null,
                call_tag:{
                    id:0,
                    content:"",
                    status:""+1,
                },

                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
              tableData: [],
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/consumers', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {

                    that.plugin = res.data.plugin;
                    that.tableData = res.data.consumers.content;
                    that.pages.total = res.data.consumers.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            statusFormat(row,column){
              return (row.user.isFreeze == 0 && row.black == false)?"正常":"封号";
            },
            sexFormat(row){
              if(row.sex == 1){
                return "男";
              }else if(row.sex == 2){
                return "女";
              }else{
                return "未知";
              }
            },
            cityFormat(row){
              return row.country+row.province+row.city;
            },

            detail(row) {
              this.$router.push({
                path: '/store/consumer/detail',query:{id:row.id}
              })
            },


        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/Consumer.vue